//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    currStep: {
      default: 1
    },
    steps: {
      default: function _default() {
        return [];
      }
    }
  }
};